import { isNumber } from 'lodash'
import React from 'react'
import { Header } from 'semantic-ui-react'
import { ReadOnlyFieldDisplay } from '../../components/ReadOnlyFieldDisplay'
import { numberToCurrency } from '../../utils'
import { helpText } from './constants'
import styles from './styles.module.less'
import { TradeFormValues } from './Types'

const FeesPreview = ({ values }: { values: TradeFormValues }) => {
  const formatValue = (value?: number) => (isNumber(value) ? numberToCurrency(value!, values.currency) : undefined)

  return (
    <div className={`trade-fees-preview ${styles.tradeFeesPreview}`}>
      <Header as="h2">Fees</Header>
      <div className={styles.feeRow}>
        <ReadOnlyFieldDisplay
          className="commission"
          helpText={helpText.commission}
          label="Commission"
          value={formatValue(values.commission)}
        />
        <ReadOnlyFieldDisplay
          className="mark-up-mark-down"
          helpText={helpText.markUpMarkDown}
          label="Mark-Up / Mark-Down"
          value={formatValue(values.markUpMarkDown)}
        />
        <ReadOnlyFieldDisplay
          className="client-clearing-fee"
          label="Client Clearing Fee"
          value={formatValue(values.clientClearingFee)}
        />
        <ReadOnlyFieldDisplay
          className="general-purpose-fee"
          label="General Purpose Fee"
          value={formatValue(values.generalPurposeFee)}
        />
        <ReadOnlyFieldDisplay
          className="liquidity-fee"
          label="Liquidity Fee"
          value={formatValue(values.liquidityFee)}
        />
        <ReadOnlyFieldDisplay
          className="trade-activity-fee"
          label="Trade Activity Fee"
          value={formatValue(values.tradeActivityFee)}
        />
      </div>
    </div>
  )
}

export default FeesPreview
